var _defs, _use, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMallAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mall-account_svg__a",
    d: "M7.2 8.4h1c.2 0 .3.1.3.3v.5c0 .2-.1.3-.3.3H6.7v.6h1.4c.2 0 .3.1.3.3v.5c0 .2-.1.3-.3.3H6.7v.9c0 .2-.1.3-.3.3H6c-.2 0-.3-.1-.3-.3v-.9H4.3c-.2 0-.3-.1-.3-.3v-.5c0-.2.1-.3.3-.3h1.4v-.6H4.3c-.2 0-.3-.1-.3-.3v-.5c0-.2.1-.3.3-.3h1L4 6.3c-.1-.1 0-.3.1-.3l.4-.2c.1-.1.3 0 .4.1l1.3 2.3 1.3-2.3c.1-.1.2-.2.4-.1l.4.2c.2 0 .2.2.1.3L7.2 8.4zM2.5 3.1h12.9c.6 0 1.1.5 1.1 1.1v9.6c0 .6-.5 1.1-1.1 1.1H2.5c-.6 0-1.1-.5-1.1-1.1V4.2c0-.6.5-1.1 1.1-1.1zm0 1.1v9.6h12.9V4.2H2.5zm7.6 6.8H14c.2 0 .3.1.3.3v.5c0 .2-.1.3-.3.3h-3.9c-.2 0-.3-.1-.3-.3v-.5c0-.2.2-.3.3-.3zm0-2.6H14c.2 0 .3.1.3.3v.5c0 .2-.1.3-.3.3h-3.9c-.2 0-.3-.1-.3-.3v-.5c0-.1.2-.3.3-.3zm0-2.5H14c.2 0 .3.1.3.3v.5c0 .2-.1.3-.3.3h-3.9c-.2 0-.3-.1-.3-.3v-.5c0-.2.2-.3.3-.3z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mall-account_svg__a",
    overflow: "visible",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "mall-account_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mall-account_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mall-account_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mall-account_svg__c",
    d: "M-898-847H526V938H-898z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mall-account_svg__c",
    overflow: "visible"
  }))));
}

export default SvgMallAccount;